var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.148,
    height: 49.5,
    viewBox: "0 0 42.148 49.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light_Paper",
    "data-name": "Iconly/Light/Paper",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paper"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke_1",
    "data-name": "Stroke 1",
    d: "M27.41,0H10.021A9.984,9.984,0,0,0,0,9.747v28A10,10,0,0,0,10.021,47.969H30.9c5.384,0,9.747-4.835,9.747-10.222V13.79Z",
    transform: "translate(0 0.031)",
    fill: "none",
    stroke: "#200e32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_3",
    "data-name": "Stroke 3",
    d: "M0,0V7.6a6.729,6.729,0,0,0,6.712,6.73c3.442.008,6.963.01,7.2-.005",
    transform: "translate(26.723)",
    fill: "none",
    stroke: "#200e32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_5",
    "data-name": "Stroke 5",
    d: "M14.106.5H0",
    transform: "translate(12.121 32.975)",
    fill: "none",
    stroke: "#200e32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_7",
    "data-name": "Stroke 7",
    d: "M8.772.5H0",
    transform: "translate(12.119 20.032)",
    fill: "none",
    stroke: "#200e32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/invoice_icon.f1e8f20b7a9c622cb6b09504c015a913.svg";
export { ForwardRef as ReactComponent };